import SimpleBoardContainer from "../board/SimpleBoardContainer";
import { POST_LABELS } from "../../../constant/PostClass";

const categories = [
  { postType: 'PT00', title: '마케팅 서비스', sectionTitle: '마케팅 서비스' }
];


const Consulting = () => {
  return (
    <SimpleBoardContainer usePinPost={true} categories={categories} postLabels={POST_LABELS.filter(l => l.value !== 'PCA01')} />
  );
}

export default Consulting;